import { render, staticRenderFns } from "./overcome-the-obstacle.vue?vue&type=template&id=aaf82504&scoped=true&"
var script = {}
import style0 from "./overcome-the-obstacle.vue?vue&type=style&index=0&id=aaf82504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf82504",
  null
  
)

export default component.exports